import styled from 'styled-components';

export const FlexColumnStyled = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;
